import { Routes } from '@angular/router';

import { PublicGuard } from 'src/app/utils/public.guard';
import { LoginComponent } from 'src/app/public/login/login.component';
import { ForgetComponent } from 'src/app/public/forget/forget.component';
import { ResetComponent } from 'src/app/public/reset/reset.component';
import { NotFoundComponent } from 'src/app/public/not-found/not-found.component';
import { MainComponent } from 'src/app/private/layout/main/main.component';
import { AuthGuard } from 'src/app/utils/auth.guard';
import { OrganizationsComponent } from 'src/app/private/modules/organizations/organizations.component';
import { OrganizationDetailsComponent } from './app/private/components/view/organization-details/organization-details.component';
import { PackagesComponent } from 'src/app/private/modules/packages/packages.component';
export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: "full",
    title: "TINA"
  },

  {
    path: 'login',
    component: LoginComponent,
    title: "TINA",
    canActivate: [PublicGuard]
  },
  {
    path: 'forget-password',
    component: ForgetComponent,
    title: "Forget Password",
    canActivate: [PublicGuard]
  },
  {
    path: 'reset-password/:type/:token',
    component: ResetComponent,
    title: "Reset Password",
    canActivate: [PublicGuard]
  },

  {
    path: 'main',
    component: MainComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        redirectTo: 'organizations',
        pathMatch: 'full' // Ensures an exact match to redirect
      },
      {
        path: 'organizations',
        component: OrganizationsComponent,
        title: "Manage Leads",
        data: {
          title: "Manage Leads"
        }
      },
      
      {
        path: 'organizations/:id',
         component: OrganizationDetailsComponent ,

        title: "Organization Details",
        data: { title: "Organization Details" }
      },

      {
        path: 'packages',
        component: PackagesComponent,
        title: "Manage Packages",
        data: {
          title: "Manage Packages"
        }
      },
      
      
    ]
  },


  { path: 'notfound', component: NotFoundComponent },
  { path: '**', redirectTo: '/notfound' }
];
